<template>
  <transition name="fade">
    <div class="card-block add-partner-block">
      <div class="add-partner-inner">
        <div class="add-partner-wrapper">
          <span>
            <svg svg-inline="" class="icon-partner" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M29.9 20.7l-4.3-1.1-1.2-4.2 4.3-4.3-1-1c-2.1-.1-4.2.7-5.7 2.2-2.2 2.2-2.8 5.3-1.8 8l-9 8.9c-1.1 1.1-1.1 2.8 0 3.899l.7.601c1.1 1.1 2.8 1.1 3.9 0l9-8.9c2.7 1 5.9.4 8.101-1.8 1.6-1.6 2.3-3.7 2.199-5.7l-1-1-4.2 4.4z" fill="#111"/></svg>
          </span>
          <p>Nie wybrałeś jeszcze preferowanego Partnera Serwisowego</p>
          <p>Dokonaj wyboru aby łatwiej umawiać wizyty</p>
        </div>
      </div>
      <div
        class="add-car-button"
        v-if="showButton"
      >
        <standard-button
          class="fluid add-partner-button"
          @buttonClick="openModal()"
          text="Wybierz Partnera Serwisowego"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapActions } from 'vuex';

export default {
  props: {
    showButton: {
      default: true,
      type: Boolean,
    },
  },
  components: {
    StandardButton,
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      setModalStep: 'modal/setModalStep',
    }),
    openModal() {
      this.setModalContent({
        changeFavourite: true,
      });
      this.setModalStep('change_partner');
      this.toggleModal();
    },
  },
};
</script>
